import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import lodashGet from 'lodash/get';
import AlphabetItem from './AlphabetItem';

const Alphabets = [
    '#',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
];

const mapArrToMap = (arr, indexingPath) => {
    const map = new Map();
    const Regx = /^[A-Za-z]$/;
    arr.forEach(item => {
        const itemName = lodashGet(item, indexingPath, '').toLowerCase();
        let firstChar = itemName[0];
        if (!Regx.test(firstChar)) {
            firstChar = '#';
        } else {
            firstChar = firstChar.toUpperCase();
        }
        if (map.get(firstChar) == null) {
            map.set(firstChar, [item]);
        } else {
            const _arr = map.get(firstChar);
            _arr.push(item);
            map.set(firstChar, _arr);
        }
    });
    return map;
};
const AlphabetList = ({generateFn, data, className, indexingPath, parentScrollerRef}) => {
    // Ref's cant be conditional, so we declare it first.
    const localScrollerRef = React.useRef();
    // use parentContianer for scrolling, if ref is available
    const scroller = parentScrollerRef || localScrollerRef;
    const [selectedChar, setSelectedChar] = React.useState('');
    const mapPos = new Map();

    const registerPos = (id, top) => {
        if (mapPos) {
            mapPos.set(id, top);
        }
    };
    const handleAlphaClick = char => {
        scroller.current.scroll({top: mapPos.get(char), behavior: 'smooth'});
    };

    const map = mapArrToMap(data, indexingPath);

    const keyArr = Array.from(map.keys());
    keyArr.sort();

    return (
        <div className={className} ref={parentScrollerRef ? null : scroller}>
            <div className="directory-list">
                {keyArr.map(char => {
                    if (map.get(char) != null) {
                        return (
                            <React.Fragment key={`listBlock-${char}`}>
                                <AlphabetItem
                                    id={`${char}`}
                                    suffix={` (${map.get(char).length})`}
                                    key={char}
                                    registerPos={registerPos}
                                >
                                    {map.get(char).map((item, index) => {
                                        return generateFn(item, index);
                                    })}
                                </AlphabetItem>
                                {map.get(char).map((item, index) => {
                                    return generateFn(item, index);
                                })}
                            </React.Fragment>
                        );
                    }
                    return null;
                })}
            </div>
            <div className="alphabets-wrapper">
                {Alphabets.map(item => {
                    return (
                        <div
                            key={`char-${item}`}
                            className={classNames({
                                'alphabet-item': true,
                                selected: item === selectedChar,
                                disabled: keyArr.indexOf(item) < 0,
                            })}
                            onClick={
                                keyArr.indexOf(item) >= 0
                                    ? () => {
                                          setSelectedChar(item);
                                          handleAlphaClick(item);
                                      }
                                    : null
                            }
                        >
                            {item}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

AlphabetList.propTypes = {
    generateFn: PropTypes.func,
    data: PropTypes.array,
    className: PropTypes.string,
    indexingPath: PropTypes.string,
    parentScrollerRef: PropTypes.object,
};

export default AlphabetList;
